/* eslint-disable no-magic-numbers */
export const DOM_READY_TIMEOUT = 1000;

export const MEDIATYPES = {
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO'
};

export const COOKIE_NAME = 'hideTradeRadioMini';
// eslint-disable-next-line id-length
export const VERY_FREQUENT_REFETCH_INTERVAL = 1000;

// Time constants for stream end checking
export const MS_PER_SECOND = 1000;
export const SECONDS_PER_HOUR = 3600;
export const MINUTE_MS = 60 * 1000;
export const CLOSE_STREAM_END = 5 * MINUTE_MS;
export const SEMI_CLOSE_STREAM_END = 30 * MINUTE_MS;
export const FREQUENT_REFETCH_INTERVAL = 30 * 1000;
export const LONG_REFETCH_INTERVAL = 5 * MINUTE_MS;
